import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { CollectionResponse } from '../models/api.model';
import { Environment } from '../models/environment.model';
import { FlaggedUser, FlaggedUserDetail, MessageFlagReason } from '../models/message-flag.model';

/**
 * Reads the automated message-flagging data (see the API's
 * lib/message-flagging.js): senders whose chat messages pushed people to
 * Telegram/WhatsApp, pitched investments or crypto, asked for money, or were
 * mass-sent verbatim to many matches.
 */
@Injectable({ providedIn: 'root' })
export class MessageFlagsService {
  constructor(
    private httpClient: HttpClient,
    @Inject('environment') private environment: Environment,
  ) {}

  /** Flag-reason catalogue, used to populate the reason filter. */
  getReasons() {
    return this.httpClient.get<{ reasons: MessageFlagReason[] }>(
      `${this.environment.api.url}/admin/message-flags/reasons`,
    );
  }

  getFlaggedUsers(
    query: string = null,
    page: number = 1,
    limit: number = 30,
    sort: string = null,
    reason: string = null,
    reportedOnly = false,
  ) {
    let params = new HttpParams()
      .append('page', `${page}`)
      .append('limit', `${limit}`);

    if (query) {
      params = params.append('query', `${query}`);
    }
    if (sort) {
      params = params.append('sort', `${sort}`);
    }
    if (reason) {
      params = params.append('reason', `${reason}`);
    }
    if (reportedOnly) {
      params = params.append('reported', 'true');
    }

    return this.httpClient.get<CollectionResponse<FlaggedUser>>(
      `${this.environment.api.url}/admin/message-flags`,
      { params },
    );
  }

  /** Every flagged message for one sender, plus the reports/blocks against them. */
  getFlaggedUserDetail(userId: number) {
    return this.httpClient.get<FlaggedUserDetail>(
      `${this.environment.api.url}/admin/message-flags/${userId}`,
    );
  }
}
